<template>
    <div class="activity">
        <main-content />
    </div>
</template>

<script>
import mainContent from '@/components/activity/index.vue'

export default {
    name: 'activity',
    components: {
        mainContent
    }
}
</script>
